import { render, staticRenderFns } from "./campaignDetail.vue?vue&type=template&id=6c2a1b35&scoped=true"
import script from "./campaignDetail.vue?vue&type=script&lang=js"
export * from "./campaignDetail.vue?vue&type=script&lang=js"
import style0 from "./campaignDetail.vue?vue&type=style&index=0&id=6c2a1b35&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2a1b35",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/saas_fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c2a1b35')) {
      api.createRecord('6c2a1b35', component.options)
    } else {
      api.reload('6c2a1b35', component.options)
    }
    module.hot.accept("./campaignDetail.vue?vue&type=template&id=6c2a1b35&scoped=true", function () {
      api.rerender('6c2a1b35', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sales/salesReps/campaignDetail.vue"
export default component.exports